module.exports = __webpack_public_path__ + "img/IND-A-2-III.417c99b6.png";